var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_135)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_21_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5C0 4.97715 4.47715 0.5 10 0.5H46C51.5228 0.5 56 4.97715 56 10.5V44.5C56 50.0228 51.5228 54.5 46 54.5H10C4.47715 54.5 0 50.0228 0 44.5V10.5Z",
    fill: "#00005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8369 38.2456V14.9082C13.8369 14.7256 13.91 14.6525 14.0926 14.6525C15.59 14.5795 18.4752 14.543 21.2508 14.543C28.6282 14.543 31.1482 18.6334 31.1482 22.5778C31.1482 28.4943 26.583 31.0143 20.9952 31.0143C19.9726 31.0143 19.79 31.0143 18.9134 31.0143V38.2091C18.9134 38.4282 18.8404 38.5012 18.5847 38.5012H14.1291C13.9465 38.5012 13.8369 38.4282 13.8369 38.2456ZM18.9134 18.9986V26.5586C19.5343 26.5951 19.936 26.5951 20.9587 26.5951C23.8073 26.5951 26.1447 25.7186 26.1447 22.6873C26.1447 20.3864 24.5743 18.9256 21.3604 18.9256C20.2282 18.9256 19.2421 18.9621 18.9134 18.9986Z",
    fill: "#9999FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6301 20.3864H38.6109C38.8301 20.3864 38.9396 20.4595 39.0492 20.6786C39.2318 21.1899 39.3779 21.9569 39.4144 22.7238C40.6196 21.2995 42.6648 20.0212 45.2214 20.0212C45.477 20.0212 45.5501 20.0943 45.5501 20.3134V24.7691C45.5501 24.9882 45.477 25.0247 45.1848 25.0247C42.5553 24.9517 40.4735 25.7186 39.6701 26.6317V38.2091C39.6701 38.4647 39.5605 38.5012 39.3414 38.5012H34.9222C34.6666 38.5012 34.557 38.4282 34.557 38.1725V25.6091C34.557 24.0021 34.5205 21.9204 34.3744 20.6056C34.3744 20.423 34.4474 20.3864 34.6301 20.3864Z",
    fill: "#9999FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 54,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_21_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 54,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProVideo);
export default __webpack_public_path__ + "static/media/Pro Video.e10fd4344047c498530ce4779db38200.svg";
export { ForwardRef as ReactComponent };